import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import AxisDetailsForm from 'containers/purchase/modules/axis_details_module/axis_details_form'
import time from 'i18n/time'

import { useTranslation } from 'react-i18next'
import { Col, Row } from 'reactstrap'
import styled from 'styled-components'

const ReturnSummary = styled.div`
  height: 100%;

  @media (min-width: 768px) {
    border-left: var(--bs-border-width) solid var(--bs-border-color);
  }
`

const SummaryContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
`

const SummaryContent = styled.div`
  width: fit-content;
  max-width: 100%;
`

const SummaryIcon = styled.i`
  width: 22px;
  flex: 0 0 22px;
  text-align: center;
`

const RouteArrow = styled.i`
  flex: 0 0 auto;
`

const AxisDetailsModule = (props) => {
  const { machine, status } = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine

  const places = props.config.product.purchase_info.places
  const accommodation = props.config.product.purchase_info.accommodation

  const context = current.context
  const quote = context?.quote_values

  const setForm = (form) => {
    send({
      type: 'DETAILS_FORM_CHANGE',
      form
    })
  }

  const passengerTypes = [
    {
      key: 'adults',
      count: Number(quote?.adults || 0)
    },
    {
      key: 'children',
      count: Number(quote?.children || 0)
    },
    {
      key: 'seniors',
      count: Number(quote?.seniors || 0)
    }
  ].filter((passenger) => passenger.count > 0)

  const getLocationName = (places, location) => {
    let place = null

    if (location?.type === 'airport') {
      place = places?.find((p) => p.code === location?.code)
    } else {
      place = accommodation
    }

    return place?.name
  }

  const pickupName = getLocationName(places, quote?.pickup)
  const dropoffName = getLocationName(places, quote?.dropoff)

  const hasReturn =
    quote?.trip_type === 'round_trip' &&
    Boolean(quote?.return_date)

  const TripSummary = ({
    title,
    date,
    origin,
    destination
  }) => (
    <SummaryContainer>
      <SummaryContent>
        <h3 className="h6 fw-bold text-primary-emphasis mb-3 text-center">
          {title}
        </h3>

        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center">
            <SummaryIcon
              className="fa fa-calendar text-secondary me-2"
              aria-hidden="true"
            />

            <span className="text-body-secondary">
              {time(date).format('LL')}
            </span>
          </div>

          <div className="d-flex align-items-center">
            <SummaryIcon
              className="fa fa-bus text-secondary me-2"
              aria-hidden="true"
            />

            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="text-body">
                {origin}
              </span>

              <RouteArrow
                className="fa fa-arrow-right text-primary"
                aria-hidden="true"
              />

              <span className="text-body">
                {destination}
              </span>
            </div>
          </div>

          <div className="d-flex align-items-start">
            <SummaryIcon
              className="fa fa-users text-secondary me-2 mt-1"
              aria-hidden="true"
            />

            <div className="d-flex flex-wrap gap-2 text-body-secondary">
              {passengerTypes.map((passenger, index) => (
                <React.Fragment key={passenger.key}>
                  {index > 0 && (
                    <span className="text-secondary">
                      ·
                    </span>
                  )}

                  <span>
                    {passenger.key == 'adults' && i18n.t('format:age_group.adults_count', {count: passenger.count})}
                    {passenger.key == 'children' && i18n.t('format:age_group.children_count', {count: passenger.count})}
                    {passenger.key == 'seniors' && i18n.t('format:age_group.seniors_count', {count: passenger.count})}
                  </span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </SummaryContent>
    </SummaryContainer>
  )

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed'
            ? send('REOPEN_DETAILSSTEP')
            : null
        }
      >
        <span>
          <i
            className="fa fa-user me-2"
            aria-hidden="true"
          />

          {i18n.t('details_module.details_title')}
        </span>
      </ModuleHeader>

      <ModuleBody status={status}>
        {quote && (
          <div className="mb-4">
            <Row className="g-4">
              <Col md={hasReturn ? 6 : 12}>
                <TripSummary
                  title={t('Vuelo de llegada')}
                  date={quote.pickup_date}
                  origin={pickupName}
                  destination={dropoffName}
                />
              </Col>

              {hasReturn && (
                <Col md={6}>
                  <ReturnSummary>
                    <TripSummary
                      title={t('Vuelo de salida')}
                      date={quote.return_date}
                      origin={dropoffName}
                      destination={pickupName}
                    />
                  </ReturnSummary>
                </Col>
              )}
            </Row>
          </div>
        )}

        <AxisDetailsForm setForm={setForm} hasReturn={hasReturn}/>
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default AxisDetailsModule
